// src/components/PreInterviewStatusColumn.js

import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import PreInterviewCard from './PreInterviewCard';

const PreInterviewStatusColumn = ({ title, interviews, onMenuOpen, onCardClick }) => { // onCardClick buraya eklendi
  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        backgroundColor: 'action.hover',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
        {title.toUpperCase()} ({interviews.length})
      </Typography>
      <Box sx={{
        overflowY: 'auto',
        flexGrow: 1,
        p: 0.5,
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'grey.400', borderRadius: '4px' }
      }}>
        {interviews.map(interview => (
          <PreInterviewCard
            key={interview.id}
            interview={interview}
            onMenuOpen={onMenuOpen}
            onCardClick={onCardClick} // ve buradan aşağıya iletildi
          />
        ))}
      </Box>
    </Paper>
  );
};

export default PreInterviewStatusColumn;